import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { WorkoutRoutine } from '../shared/round/round.component';
import * as _ from 'lodash';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const workoutFile = "../../assets/data/workouts.json";

/*export enum Equip {

  Blah ={fff:'ff'},

}*/
//  export mystuff = [{ name: 'one', url: 'fff', value: 10 },
// { name: 'two', url: 'fff', value: 10 },
// { name: 'three', url: 'fff', value: 10 }
// ];

/*export enum Equipment {
  PULLUP_BAR = 1,
  DUMBELLS = 2,
  DIP_MACHINE = 3,
  PUSHUP_STANDS = 4,
  MEDICINE_BALLS = 5,
  BOSU_BALL = 6,
  STABILITY_BALL = 7,
  RESISTANCE_BANDS = 8,
  TRX = 9
}*/

@Injectable({
  providedIn: 'root'
})
export class HttpJsonService {

  static mystuff = [
    { text: 'Pullup Bar', url: 'one.com', value: 1 },
    { text: 'Dumbells', url: 'two.com', value: 2 },
    { text: 'Dip Machine', url: 'three.com', value: 3 },
    { text: 'Pushup Stands', url: 'three.com', value: 4 },
    { text: 'Medicine ball (s)', url: 'three.com', value: 5 },
    { text: 'BOSU ball', url: 'three.com', value: 6 },
    { text: 'Stability ball', url: 'three.com', value: 7 },
    { text: 'Resistance bands', url: 'three.com', value: 8 },
    { text: 'TRX', url: 'three.com', value: 9 }
  ];

  constructor(private http: HttpClient) { }

  getData(): Observable<any> {
    return this.http.get(workoutFile, httpOptions).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }

  /**
   * Min and max included.
   * @param min min
   * @param max max
  */
  randomIntFromInterval(min, max) {
    // let ran = Math.floor(min + Math.random()*(max + 1 - min));
    let ran = _.random(min, max);
    console.log('getting random number between: ' + min + ' and: ' + max + ' got: ' + ran);

    return ran;
    // return Math.floor(Math.random() * (max - min + 1) + min);
  }

  /**
   * Takes in a comma-delimited string of numbers, returns them as an array like: [1, 2, 7, 5]
   * @param csvString a string like '1,2,7,5
   */
  convertCSVStringToNumberArray(csvString: string) {

    let numArray: number[] = new Array();
    if (csvString) {
      let split = csvString.split(',');
      if (split.length > 0) {
        numArray = new Array();
        let cnt = 0;
        split.forEach(element => {
          numArray[cnt++] = parseInt(element);
        });
      }
    }

    return numArray;
  }

  /**
   * Gets the shuffled routine indexes
   * 
   * @param routs the routines
   * @param howMany how many shuffled routine indexes to get
   * @param difficulties a commma-delimited string of the numbers for the difficulty levels to include, such as 1,2,3, if blank, will return routines with all difficulty levels
   */
  getShuffledRoutineIndexesFilteringByDifficulty(routs: WorkoutRoutine[], howMany: number, difficulties: string) {
    let difficultyAsNumberArray = this.convertCSVStringToNumberArray(difficulties);
    console.log('difficulties: ' + difficulties);

    let indexes: number[] = new Array();
    let indexCounter = -1;

    let filteredRoutines = routs.filter(routine => {
      indexCounter++;
      // console.log('looking at difficulty: ' + routine.difficulty);
      if (routine.difficulty != undefined && difficultyAsNumberArray.indexOf(routine.difficulty) != -1) {
        // console.log('**hit with difficulty: ' + routine.difficulty);
        indexes.push(indexCounter);
        return true;
      }
    });

    console.log('filtered routines len: ' + filteredRoutines.length);

    let shuffled: number[] = this.shuffle(indexes);
    let sliced: number[];

    if (howMany > shuffled.length) {
      sliced = shuffled.slice(0, shuffled.length);
    } else {
      sliced = shuffled.slice(0, howMany);
    }

    console.log('returning: ' + sliced.length);
    return sliced;
  }

  /**
   * Gets the shuffled routine indexes
   * 
   * @param routs the routines
   * @param howMany how many shuffled routine indexes to get
   * @param equipmentNeeded the number[] of the equipment needed for the set of routines (i.e. will return routines WITH that equipment if set), if undefined only returns routines with no equipment needed, send in blank array for all
   * @param returnOnlyItemsWithEquipment if you ONLY want a list of the routines with the given equipment set this to true
   */
  getShuffledRoutineIndexes(routs: WorkoutRoutine[], howMany: number, equipmentNeeded: number[] = undefined, returnOnlyItemsWithEquipment: boolean = false) {

    console.log('equip needed: ' + equipmentNeeded);

    let indexes: number[] = new Array();
    let indexCounter = -1;

    let filteredRoutines = routs.filter(routine => {
      indexCounter++;

      if (equipmentNeeded && equipmentNeeded.length == 0) { //user wants all routines (even with equipment)
        indexes.push(indexCounter);
      } else {
        if (routine.equipment && equipmentNeeded) { //some equipment needed
          console.log('looking at: ' + routine.equipment + ' against: ' + equipmentNeeded);
          let hit = _.difference(routine.equipment, equipmentNeeded).length === 0;

          if (hit) {
            indexes.push(indexCounter);
            console.log('adding one that needs equipment: ' + routine.name + ' looking at: ' + routine.equipment + ' against: ' + equipmentNeeded);
          }
          return hit;
        } else { //no equipment needed
          if (!returnOnlyItemsWithEquipment) {
            indexes.push(indexCounter);
          }
        }
      }

    });

    let shuffled: number[] = this.shuffle(indexes);
    let sliced: number[];

    if (howMany > shuffled.length) {
      sliced = shuffled.slice(0, shuffled.length);
    } else {
      sliced = shuffled.slice(0, howMany);
    }

    console.log('returning: ' + sliced.length);
    return sliced;
  }

  /**
   * Shuffles an array of numbers
   * @param toShuffle The array to shuffle
   */
  private shuffle(toShuffle: number[]) {
    let shuffled = new Array(toShuffle.length);

    for (var i = 0; i < shuffled.length; i++) {
      shuffled[i] = toShuffle[i];
    }

    var i = shuffled.length,
      j = 0,
      temp;

    while (i--) {

      j = Math.floor(Math.random() * (i + 1));

      temp = shuffled[i];
      shuffled[i] = shuffled[j];
      shuffled[j] = temp;
    }

    return shuffled;
  }


  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }

  private extractData(res: Response) {
    let body = res;
    return body || {};
  }
}
